import { menu } from './menu';
import { router } from './router';

export const Pneu = {
	menu,
	router,
};
